module.exports = __webpack_public_path__ + "img/nature-76.2ab26cf5.jpg";